import * as React from 'react'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import Tooltip from 'modules/timeoff/components/Leaves/Overview/NewStatsCounter/Tooltip'
import type Allowance from 'modules/timeoff/store/models/Allowance'
import type AllowanceStat from 'modules/timeoff/store/models/AllowanceStat'
import type { Cycle } from 'modules/timeoff/store/models/AllowanceStat'

import Section from './components/Section'

// import Advance from './components/Advance'
interface Props {
  selectedStat: AllowanceStat
  allowance: Allowance
  remainingCarryover: number
  remainingAdjustment: number
  remainingDays: number
  usedDays: number
  selectedCycle: Cycle
  nextCycle: Cycle | null | undefined
}

const TakenTooltip = ({
  selectedStat,
  allowance,
  remainingCarryover,
  remainingAdjustment,
  remainingDays,
  usedDays,
  nextCycle,
}: Props) => {
  const stat = selectedStat.toJS()
  const totalCarryover = stat.accumulated_carry_over
  const totalAdjustment = stat.incidences
  const totalDays = stat.prorated_allowance_days

  const checkIfCarrysAndAdjustmentsExhausted =
    remainingCarryover <= 0 && remainingAdjustment <= 0 && remainingDays <= 0

  const title = allowance.isDays
    ? i18n.t('time_off.taken_tooltip.taken_days')
    : i18n.t('time_off.taken_tooltip.taken_hours')

  const carryOverTitle = allowance.isDays
    ? i18n.t('time_off.new_taken_tooltip.carryover.days')
    : i18n.t('time_off.new_taken_tooltip.carryover.hours')

  return (
    <Tooltip title={title}>
      <>
        {totalCarryover > 0 && (
          <Section
            amount={totalCarryover - remainingCarryover}
            text={carryOverTitle}
            remainder={remainingCarryover < 0 ? 0 : remainingCarryover}
            allowance={allowance}
          />
        )}

        {totalAdjustment > 0 && (
          <Section
            amount={totalAdjustment - remainingAdjustment}
            text={i18n.t('time_off.new_taken_tooltip.adjustment')}
            remainder={remainingAdjustment < 0 ? 0 : remainingAdjustment}
            allowance={allowance}
          />
        )}

        <Section
          amount={totalDays - remainingDays}
          text={i18n.t('time_off.new_taken_tooltip.cycle')}
          remainder={remainingDays < 0 ? 0 : remainingDays}
          allowance={allowance}
        />

        {usedDays > 0 && checkIfCarrysAndAdjustmentsExhausted && (
          <Section
            amount={usedDays}
            text={i18n.t('time_off.new_taken_tooltip.advance', {
              cycle: nextCycle?.yearLabel,
            })}
            remainder={remainingAdjustment < 0 ? 0 : remainingAdjustment}
            allowance={allowance}
          />
        )}

        {/* transfer for now to total tooltip */}

        {/* {totalCarryover < 0 && (
         <Advance
           amount={Math.abs(totalCarryover)}
           text={i18n.t('time_off.new_taken_tooltip.given_advance')}
           cycle={selectedCycle.yearLabel}
           allowance={allowance}
         />
        )} */}
      </>
    </Tooltip>
  )
}

export default observer(TakenTooltip)
